import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  blur?: boolean;
};
/** Soft blur + slide reveal on scroll into view. */
export function Reveal({
  children,
  delay = 0,
  y = 36,
  className = '',
  blur = true
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y,
    filter: blur ? 'blur(12px)' : 'blur(0px)'
  }} whileInView={{
    opacity: 1,
    y: 0,
    filter: 'blur(0px)'
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.9,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-98" data-mp="1p56cveufmf99">
      {children}
    </motion.div>;
}
type SplitProps = {
  text: string;
  className?: string;
  delay?: number;
  as?: 'h1' | 'h2' | 'h3' | 'p' | 'span';
  stagger?: number;
};
/** Word + character stagger reveal that slides upward. */
export function SplitText({
  text,
  className = '',
  delay = 0,
  as = 'h2',
  stagger = 0.03
}: SplitProps) {
  const words = text.split(' ');
  const Tag = motion[as] as any;
  return <Tag className={className} initial="hidden" whileInView="show" viewport={{
    once: true,
    margin: '-60px'
  }} aria-label={text} data-id="element-99" data-mp="3pj68byfcip49">
      {words.map((word, wi) => <span key={wi} className="inline-block whitespace-nowrap" aria-hidden data-id="element-100" data-mp="2wv0oddw4945h" data-mpi={wi}>
          {word.split('').map((char, ci) => <motion.span key={ci} className="inline-block" variants={{
        hidden: {
          y: '100%',
          opacity: 0,
          filter: 'blur(6px)'
        },
        show: {
          y: '0%',
          opacity: 1,
          filter: 'blur(0px)',
          transition: {
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1],
            delay: delay + (wi * word.length + ci) * stagger
          }
        }
      }} style={{
        display: 'inline-block'
      }} data-id="element-101" data-mp="31ttz4yk0qh1y" data-mpi={ci}>
              {char}
            </motion.span>)}
          <span className="inline-block" data-id="element-102" data-mp="3q6p8st2d27j3">&nbsp;</span>
        </span>)}
    </Tag>;
}